import { UserSubscriptionStatus } from "@nf/common";

export const isSubscriptionHold = (
  subscriptionStatus?: UserSubscriptionStatus
) => subscriptionStatus && subscriptionStatus === UserSubscriptionStatus.HOLD;
